import { getEnv } from '@config';

const { country } = getEnv();

export const accountTypesMockChile = [
  {
    account_type_code: 'CC',
    product_code: '01',
    description: 'Cuenta corriente',
    sub_product_code: '1-201',
  },
  {
    account_type_code: 'CV',
    product_code: '05',
    description: 'Cuenta vista',
    sub_product_code: '1-201',
  },
];

export const saparateDocSelected = ' - ';

const bankAccountTypeCh = {
  '05': 'Cuenta vista',
  '01': 'Cuenta corriente',
  CC: 'Cuenta corriente',
  CV: 'Cuenta vista',
};

const bankAccountTypePe = {
  '08': 'Cuenta Ahorro',
  '01': 'Cuenta Corriente',
  15: 'Cuenta Maestra',
  CA: 'Cuenta Ahorro',
  CC: 'Cuenta Corriente',
};

const bankAccountTypeCo = {
  '02': 'Cuenta de Ahorro',
  '04': 'Cuenta Corriente',
  CA: 'Cuenta ahorro',
  CC: 'Cuenta corriente',
};

export const bankAccountType = {
  cl: bankAccountTypeCh,
  pe: bankAccountTypePe,
  co: bankAccountTypeCo,
}[country];

export const bankAccountTypePeru = [
  { value: '08', text: 'Cuenta Ahorro' },
  { value: '01', text: 'Cuenta Corriente' },
  { value: '15', text: 'Cuenta Maestra' },
];

export const bankAccountTypeColombia = [
  { value: 'CA', text: 'Cuenta ahorro' },
  { value: 'CC', text: 'Cuenta corriente' },
];
